import { apiDelete, apiGet, apiPost, apiPut } from './api-service';
import { getUserDetails } from './session-service';

export async function getAll() {
    try {
        const response = await apiGet('core', `equipment`);
        return response;
    } catch (e) { }
}

export async function getEquipment(id?: string) {
    try {
        const response = await apiGet('core', `equipment/${id}`);
        return response.content;
    } catch (e) {
        return {};
    }
}


export async function addEquipment(newDetails: any) {
    try {
        const response = await apiPost('core', `equipment`, newDetails);
        return response;
    } catch (e) { }
}

export async function updateEquipment(newDetails: any, id?: string) {
    try {
        if (!id) {
            id = getUserDetails().client_id;
        }
        const response = await apiPut('core', `equipment/${id}`, newDetails);

        return response.content;
    } catch (e) { }
}

export async function removeEquipment(id: any) {
    try {

        return await apiDelete('core', `equipment/${id}`);
    } catch (e) { }
}

export async function duplicateEquipment(id?: string) {
    try {
        const response = await apiGet('core', `equipment-duplicate/${id}`);
        return response.content;
    } catch (e) {
        return {};
    }
}